// product types that let the shipper freely choose pickup/dropoff day and hours
export const FLEX_LIKE_PRODUCT_TYPES = ['STANDARD', 'PALLET_NETWORK'];

export const isFlexLikeProduct = (productType) =>
  FLEX_LIKE_PRODUCT_TYPES.includes(productType);
